<mat-card class="danger-card">
  <mat-card-header class="danger-header">
    <mat-card-title class="danger-title">Danger zone</mat-card-title>
  </mat-card-header>
  <mat-divider aria-hidden="true"></mat-divider>
  <mat-card-content class="danger-body">
    <div class="settings-row">
      <div class="settings-row-info">
        <div class="settings-row-label">Delete profile</div>
        <div class="settings-row-desc">
          This will permanently delete your profile data. You'll be asked to set it up again.
        </div>
      </div>
      @if (!showConfirm) {
        <button
          mat-flat-button
          class="btn-danger"
          (click)="confirmDelete()"
          aria-label="Delete your profile"
        >
          Delete profile
        </button>
      }
    </div>

    @if (showConfirm) {
      <div
        class="confirm-box"
        role="alertdialog"
        aria-live="assertive"
        aria-label="Confirm profile deletion"
      >
        <p class="confirm-text">Are you sure? This cannot be undone.</p>
        <div class="confirm-actions">
          <button
            mat-stroked-button
            class="btn-outline"
            (click)="cancelDelete()"
            aria-label="Cancel — keep my profile"
          >
            Cancel
          </button>
          <button
            mat-flat-button
            class="btn-danger"
            (click)="deleteProfile()"
            [disabled]="isDeleting"
            [attr.aria-label]="
              isDeleting ? 'Deleting your profile' : 'Confirm — yes delete my profile'
            "
          >
            {{ isDeleting ? 'Deleting...' : 'Yes, delete my profile' }}
          </button>
        </div>
        @if (error) {
          <p class="error-text" role="alert">{{ error }}</p>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
